<template>
  <div class="paper-date-wrapper">
    <el-date-picker
        class="paper-date-picker"
        v-model="date"
        ref="datePicker"
        :align="align"
        size="mini"
        type="date"
        placeholder="选择日期"
        :popper-class="popperClass"
        :editable="false"
        :picker-options="pickerOptions"
        value-format="yyyyMMdd"
        @change="change"
        @focus="focus"
        @blur="blur"
    >
    </el-date-picker>
  </div>
</template>

<script>
export default {
  name: 'PaperDatePicker',
  data() {
    return {
      date: '',
      visible: false, // 标识移动端日期是否为展示状态
      allYearPapers: [],
      searchYear: new Date().getFullYear(),
      pickerOptions: {
        disabledDate: this.disabledDate,
        cellClassName: this.cellClassName // 因移动端需要在change时更新日期收起状态， 所以用cellClassName来标识当前选中日期
      },
      childHandleClose: null // 移动端时用来存储组件handleClose方法
    }
  },
  props: {
    align: {
      type: String,
      default: 'left'
    },
    allBooks: {
      type: Array,
      default: function() {
        return []
      }
    },
    paperStyle: {
      type: Boolean,
      default: false
    },
    baozhiId: {
      default: null
    },
    isShare: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isPaper() {
      return this.$store.state.book.isPaper || this.$store.state.config.paperStyle == 1
    },
    isMobile() {
      return this.$store.state.book.isMobile
    },
    popperClass() {
      if (this.isMobile) {
        return 'paper-popper date-mobile'
      } else {
        return 'paper-popper'
      }
    },
    // 当前报刊日期
    curPublishDate() {
      return this.$store.state.config.bookObj.publishDate
    }
  },
  created() {
    this.loadHistoryBaokanList()
  },
  mounted() {
    // 移动端拦截clickoutside触发的动作
    if (this.isMobile) {
      this.childHandleClose = this.$refs.datePicker.handleClose
      this.$refs.datePicker.handleClose = this.handleClose
    }
  },
  methods: {
    // 根据接口返回信息，进存在书刊的日期可选择
    disabledDate(time) {
      if (window.PROJECT_CONFIG.HISTORY_URL) {
        let month = time.getMonth() + 1;
        let date = time.getDate();
        let fullDate = time.getFullYear() + (month > 9 ? '' : '0') + month + (date > 9 ? '' : '0') + date
        return !this.allYearPapers.includes(fullDate)
      }
    },
    // 当前日期标识选中样式
    cellClassName(time) {
      let date = new Date(this.curPublishDate)
      if (date.getFullYear() === time.getFullYear() && date.getMonth() === time.getMonth() && date.getDate() === time.getDate()) {
        return 'selected'
      }
    },
    // PC端用blur和focus来控制标识日历展开状态
    blur() {
      this.$emit('updateVisible', false)
      $('.el-date-picker .el-date-picker__header button.el-icon-d-arrow-left,.el-date-picker .el-date-picker__header button.el-icon-d-arrow-right').off('click')
      $('.el-date-picker .el-date-picker__header button.el-icon-arrow-left,.el-date-picker .el-date-picker__header button.el-icon-arrow-right').off('click')
      $('.el-date-picker .el-picker-panel__content .el-year-table td a').off('click')
    },
    focus() {
      this.$emit('updateVisible', true)
      this.$nextTick(() => {
        this.updateDatePicker()
      })
    },
    change() {
      if (this.date) {
        let location = window.location.href.split('/index.html')[0]
        window.location.href = location.slice(0, location.lastIndexOf('/')) + '/' + this.date + '/index.html'
      }
    },
    // 移动端通过手动方式触发
    updateStatus() {
      if (this.visible) {
        this.childHandleClose()
        this.visible = false
      } else {
        this.$refs.datePicker.handleFocus()
        this.visible = true
      }
    },
    // 移动端可能出现日历展示状态，展示日历按钮位置改变的情况，需手动更新日历位置
    resetPopperPosition() {
      this.$refs.datePicker.createPopper()
    },
    updateDatePicker() {
      const $el = $('.el-date-picker .el-picker-panel__content .el-year-table td,.el-date-picker .el-picker-panel__content .el-month-table td')
      $el.removeClass('disabled')
      const monthEle = $('.el-date-picker .el-date-picker__header span:last-of-type')
      if (this.isPaper) {
        $('.el-date-picker .el-date-picker__header button.el-icon-d-arrow-left,.el-date-picker .el-date-picker__header button.el-icon-d-arrow-right').on('click', (e) => {
          if (e.target.className.indexOf('el-icon-d-arrow-right') > 0) {
            this.searchYear++
          } else {
            this.searchYear--
          }
          this.loadHistoryBaokanList()
        })
        $('.el-date-picker .el-date-picker__header button.el-icon-arrow-left,.el-date-picker .el-date-picker__header button.el-icon-arrow-right').on('click', (e) => {
          if (monthEle.length > 0) {
            const month = parseInt(monthEle.text())
            if (e.target.className.indexOf('el-icon-arrow-left') > 0 && month === 12) {
              this.searchYear--
              this.loadHistoryBaokanList()
            } else if (e.target.className.indexOf('el-icon-arrow-right') > 0 && month === 1) {
              this.searchYear++
              this.loadHistoryBaokanList()
            }
          }
        })
        $('.el-date-picker .el-picker-panel__content .el-year-table td a').on('click', (e) => {
          this.searchYear = e.target.innerHTML
          this.loadHistoryBaokanList()
          $el.removeClass('disabled')
        })
      }
    },
    loadHistoryBaokanList() {
      if (window.PROJECT_CONFIG.HISTORY_URL) {
        const _this = this
        const params = {yearStr: this.searchYear, id: 2}
        $.ajax({
          url: window.PROJECT_CONFIG.HISTORY_URL,
          type: 'GET',
          data: params,
          success: function(res) {
            const data = typeof res == 'string' ? JSON.parse(res) : res
            console.log(data)
            if (data.status == 0) {
              _this.$set(_this, 'allYearPapers', data.data)
            }
          }
        })
      }
    },
    // 方法覆写，预留
    handleClose() {}
  }
}
</script>

<style lang="scss">
body {
  .paper-popper {
    .popper__arrow {
      display: none;
    }
  }
}

.paper-date-wrapper {
  opacity: 0;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;

  &.visible {
    z-index: -1;
  }

  .el-date-editor.el-input {
    width: 100%;
    height: 100%;

    .el-input__inner {
      padding-left: 13px;
      padding-right: 13px;
      height: 100%;
      width: 32px;
    }
  }
}

.date-mobile {
  z-index: 99 !important;
  right: 10px !important;
  left: unset !important;
}
</style>
